export default __webpack_public_path__ + "static/media/news_coverage.544ed64f.svg";